import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { AppendToBodyModule } from 'NewAngular/features/directives/append-to-body/append-to-body.module';
import * as i0 from "@angular/core";
export class SingleSelectDropdownModule {
}
SingleSelectDropdownModule.ɵfac = function SingleSelectDropdownModule_Factory(t) { return new (t || SingleSelectDropdownModule)(); };
SingleSelectDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SingleSelectDropdownModule });
SingleSelectDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule, FeatureNeededModule, FormsModule, HelpModalModule, AppendToBodyModule] });
